import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import { Card, CardBody, FormGroup, Label } from "reactstrap";
import { ReactComponent as DeleteIcon } from "../../../../../assets/utils/images/svgs/Delete.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import { Col, Row } from "react-bootstrap";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import { BsCheckCircle } from "react-icons/bs";
import { useSaveCoordinatorIcon } from "Api/Admin/Besturen/Algemeen";
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";

const Coordinatoren = ({ coordinatorData, addOrDeleteMelderHandler }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
    const [fieldState, setFieldState] = useState({});
    const { trigger: saveCoordinatorIcon } = useSaveCoordinatorIcon();

    useEffect(() => {
        // Returning `prev` unchanged lets React bail out of the re-render, so an
        // unstable `coordinatorData` reference cannot spin this effect into an
        // update loop that trips the nested-update limit (error #185).
        setFieldState((prev) => {
            const next = coordinatorData.reduce((acc, field) => {
                acc[field.iCoordId] = field.eRecievePlanning;
                return acc;
            }, {});
            const nextKeys = Object.keys(next);
            const unchanged =
                nextKeys.length === Object.keys(prev).length &&
                nextKeys.every((key) => prev[key] === next[key]);

            return unchanged ? prev : next;
        });
    }, [coordinatorData]);


    const handleIconChange = (iCoordId, iCommunityId, currentRecievePlanning) => {

           const newPlanning = currentRecievePlanning === "1" ? "Y" : "N";

        // Prevent unnecessary API call if status is unchanged
        if (fieldState[iCoordId] === newPlanning) {
            return;
        }
        
        const data = {
            iCoordId,
            iCommunityId,
            eRecievePlanning: newPlanning,
        };


        saveCoordinatorIcon({
            data
        })
            .then((response) => {

                setFieldState((prevState) => ({
                    ...prevState,
                    [iCoordId]: newPlanning,
                }));
            })
            .catch((error) => {
                console.error("API Error:", error.response || error.message);
            });
    };

    return (
        <Card className="main-card pb-4">
            <CardBody className="d-flex flex-column">
                <div className="btn-color-style travelCost-blue-text mb-4">Coördinatoren</div>
                <Formik enableReinitialize validateOnChange={true}>
                    {() => (
                        coordinatorData?.length > 0 ? (
                            <Form className="melder-list " style={{ overflowX: 'hidden' }} >
                                <div className="mb-4">
                                    <Row >
                                        <Col md={4}></Col>
                                        <Col md={4} className="fw-bolder">Bestuurs/school-info</Col>
                                        <Col md={4} className="fw-bolder">Verwijderen</Col>
                                    </Row>
                                </div>
                                {coordinatorData.map((field) => (
                                    <FormGroup key={field.iCoordId}>
                                        <Row>
                                            <Col md={4}>
                                                <Label for={field}>{field?.name}</Label >
                                            </Col>
                                         
                                            <Col md={4}>
                                                <>
                                                    <div
                                                        className="ms-5 svg-pointer">
                                                        <GroupStatus
                                                            field="status"
                                                            data={fieldState[field.iCoordId] === "Y" ? 1 : 0}
                                                             iconChangeHandler={(fieldName, data) =>
                                                                handleIconChange(
                                                                    field.iCoordId,
                                                                    field.iCommunityId,
                                                                    data
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </>
                                            </Col>
                                            <Col md={4} className="align-item-center">
                                                <div className="position-relative">
                                                    <div className="d-flex gap-1 align-items-center ms-4">
                                                        <div
                                                            onClick={() => {
                                                                setSelectedField(field);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            className="d-flex svg-pointer"
                                                        >
                                                            <DeleteIcon />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                ))}
                            </Form>
                        ) : (
                            <p className="text-center">Gegevens zijn niet aanwezig</p>
                        )
                    )}
                </Formik>
            </CardBody>

            <SweetAlert
                title="Weet je zeker dat je dit wilt verwijderen?"
                show={showDeleteModal}
                type="warning"
                confirmBtnText="OK"
                cancelBtnText="Annuleren"
                showCancel
                onConfirm={() => {
                    if (selectedField) {
                        addOrDeleteMelderHandler(
                            "remove",
                            selectedField?.iCoordId,
                            selectedField?.iCommunityId
                        );
                    }
                    setShowDeleteModal(false);
                }}
                onCancel={() => setShowDeleteModal(false)}
            />
        </Card>
    );
};

export default Coordinatoren;